<template>
  <div class="admin-login">
    <el-card class="login-card" shadow="always">
      <div slot="header" class="login-title">管理端登录</div>
      <el-form :model="form" label-position="top" @submit.native.prevent="onSubmit">
        <el-form-item label="账号">
          <el-input v-model="form.username" placeholder="请输入账号" />
        </el-form-item>
        <el-form-item label="密码">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="请输入密码"
            show-password
            @keyup.enter.native="onSubmit"
          />
        </el-form-item>
        <el-button
          type="primary"
          class="login-btn"
          :loading="loading"
          @click="onSubmit"
          >登录</el-button
        >
      </el-form>
    </el-card>
  </div>
</template>

<script>
import auth from '../auth'

export default {
  name: 'AdminLogin',
  data() {
    return {
      form: { username: '', password: '' },
      loading: false,
    }
  },
  methods: {
    async onSubmit() {
      this.loading = true
      try {
        await auth.login(this.form.username, this.form.password)
        const redirect = this.$route.query.redirect || '/admin/dashboard'
        this.$router.replace(redirect)
      } catch (e) {
        this.$message.error((e && e.message) || '登录失败')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.admin-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f2f5;
}
.login-card {
  width: 360px;
}
.login-title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.login-btn {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/admin/views/Login.vue